export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/catalog_design.f711a02.svg";